import { definedMapWithDefault } from "collection-utils";

import { asString, asNumber, loadedDefinedMap, asBoolean } from "common/components/component-helpers";
import { LOADING } from "common/components/types";
import type { GlideFunctionalRenderer } from "common/components/uis";
import ProgressIndicator from "webapp/ui/smart/progress-indicator/progress-indicator";
import { useForceValueProducers } from "hooks/use-value-producers";
import { useForce } from "hooks/use-force";
export const ProgressMaterialRenderer: GlideFunctionalRenderer = p => {
    const { env, getValueProducers, ctx } = p;
    const [force] = useForce();
    const [
        [valuePV, minimumPV, maximumPV, titlePV, captionPV, showTotalPV, stylePV, formattedPV],
    ] = useForceValueProducers(getValueProducers, force, ctx);

    if (
        valuePV === LOADING ||
        titlePV === LOADING ||
        captionPV === LOADING ||
        minimumPV === LOADING ||
        maximumPV === LOADING
    ) {
        return env.renderProgress();
    }

    const value = definedMapWithDefault(valuePV, 0, asNumber);
    if (value === undefined) {
        return env.renderProgress();
    }

    let minimum = definedMapWithDefault(minimumPV, 0, v => parseFloat(asString(v)));
    let maximum = definedMapWithDefault(maximumPV, 100, v => parseFloat(asString(v)));
    const title = definedMapWithDefault(titlePV, "", asString);
    const caption = definedMapWithDefault(captionPV, "", asString);
    const formatted = definedMapWithDefault(formattedPV, value.toString(), asString);

    const showTotal = loadedDefinedMap(showTotalPV, asBoolean);
    const style = loadedDefinedMap(stylePV, asString);

    if (isNaN(minimum)) {
        minimum = 0;
    }

    if (isNaN(maximum)) {
        maximum = 100;
    }

    return (
        <ProgressIndicator
            style={style as any}
            value={value}
            minimum={minimum}
            maximum={maximum}
            title={title}
            caption={caption}
            showTotal={showTotal}
            formatted={formatted}
        />
    );
};
